import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSquareBehindSquare3"><Path d="M8.75 15.25V19C8.75 20.2426 9.75736 21.25 11 21.25H19C20.2426 21.25 21.25 20.2426 21.25 19V11C21.25 9.75736 20.2426 8.75 19 8.75H15.25M13 15.25H5C3.75736 15.25 2.75 14.2426 2.75 13V5C2.75 3.75736 3.75736 2.75 5 2.75H13C14.2426 2.75 15.25 3.75736 15.25 5V13C15.25 14.2426 14.2426 15.25 13 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
